// eslint-disable-next-line import/prefer-default-export
export const SET_PRE_OT_ELIGIBLE_DATA = 'SET_PRE_OT_ELIGIBLE_DATA';
export const SET_PRE_OT_AVAILABLE_DATE_LIST = 'SET_PRE_OT_AVAILABLE_DATE_LIST';
export const SET_CALCULATED_OT_HOUR = 'SET_CALCULATED_OT_HOUR';
export const CLEAR_CALCULATED_OT_HOUR = 'CLEAR_CALCULATED_OT_HOUR';

export const SUBMIT_PRE_OVERTIME_REQUEST_SUCCESS =
  'SUBMIT_PRE_OVERTIME_REQUEST_SUCCESS';
export const SUBMIT_PRE_OVERTIME_REQUEST_ERROR =
  'SUBMIT_PRE_OVERTIME_REQUEST_ERROR';
export const SUBMIT_PRE_OVERTIME_REQUEST_PENDING =
  'SUBMIT_PRE_OVERTIME_REQUEST_PENDING';
export const SET_SUBMIT_PRE_OVERTIME_REQUEST_INITIAL_STATE =
  'SET_SUBMIT_PRE_OVERTIME_REQUEST_INITIAL_STATE';
export const SET_SELECTED_PRE_OT_DATE_DETAILS =
  'SET_SELECTED_PRE_OT_DATE_DETAILS';
